module.exports = {
  noResult: 'No Result',
  selected: 'Selected',
  unseleted: 'Unselected',
  productManager: 'Product Manager',
  productInfo: 'Product Info',
  selectedProduct: 'Selected item({args1})',
  managerMenu: 'Manage Menu',
  productMenu: 'Product Menu',
  pleaseCheckProduct: 'Please tick the product first',
  menu: 'Menu',
  duplicateSpecificationNameErrorTips: 'Duplicate specification name',
  startTimeNotMoreThanEndTime: 'Start time cannot be greater than end time!',
  dragSort: 'Draggable Sort',
  addClassification: 'Add Category',
  addProduct: 'Add Product',
  editProduct: 'Edit Product',
  sort: 'Sort',
  productSort: 'Product Sort',
  menuName: 'Menu Name',
  menuId: 'Menu ID',
  everyDay: 'Every Day',
  pleaseInputProductCategory: 'Please enter product category',
  classificationShow: 'Display Settings',
  productNum: 'Product Number',
  checkMenuTips: 'Please check at least one menu item !',
  confirmBatchDelMenu: 'Are you sure to delete {args1} menus',
  noMenuId: 'The system automatically generates no need to fill in',
  classfications: 'Category',
  classfication: 'Category List',
  every: 'Every',
  all: 'All',
  addOrEdit: 'Add/Edit Product',
  productList: 'Product List',
  productName: 'Product Name',
  productStatus: 'Stock Status',
  salesStatus: 'Sales Status',
  activityStatus: 'Active Status',
  soldOut: 'Sold Out',
  inStock: 'In Stock',
  productID: 'Product ID',
  productPrice: 'specification price',
  lunchBoxFee: 'Packaging Fee',
  stock: 'Stock',
  salesMount: 'Sales Number',
  activityDiscount: 'Activity Discount',
  onShelf: 'On Sale',
  unShelf: 'Off Shelf',
  discount: 'Reduce price',
  productImage: 'Product Image',
  noLink: 'Not Associated',
  toZero: 'Clear',
  salesRaking: 'Sales Sort',
  productDesc: 'Product Description',
  newProduct: 'New Product',
  deleteProduct: 'Are you sure to delete {args1} items?',
  zeroProduct: 'Clear,Are you confirm',
  linkStatus: 'Activity Schedule',
  productSpecification: 'Product Specification',
  productAttr: 'Product Attributes',
  currentInventory: 'Current Inventory',
  full: 'Full',
  autoFull: 'Auto-fill',
  dailyAutoFull: 'Daily 04:00 automatically set full inventory',
  maxValue: 'Maximum inventory',
  addSpecification: 'Add Specifications',
  specification: 'Specification',
  barCode: 'BarCode',
  productPrice: 'Item Price',
  addAttributes: 'Add Option',
  attributesName: 'Property Name',
  attributesConfig: 'Property Setting',
  option: 'Option',
  markUp: 'Markup',
  RequiredItem: 'Required Need Select',
  item: 'Item',
  optionalItem: 'Optional Most Select',
  productDiscount: 'Item Promotions',
  hotProduct: 'Special Offer',
  explosiveProductPrice: 'Hot Sale',
  noTranslate: 'Not Translated',
  setLunchBox: 'Set Lunch box Free',
  lunchBoxContent: "Setting pakaging fee will effect customer order,do you confirm?",
  noSelectCategory: 'No product menu set, submit?',
  importType: 'Import Type',
  onlyInsertData: 'Create Data',
  onlyUpdateData: 'Update Data',
  reSelect: 'Re-select',
  selectFile: 'Selected File',
  illustrate: 'Tips',
  illustrate1: '1.The import file only support.xlsx format；',
  illustrate2: '2.Please put all the data in the first sheet；',
  illustrate3: '3.When update data, please import it base on the export data(with id)；',
  illustrate4: '4.The maximum of import data is 1000；',
  illustrate5: '5.Please be aware this process will not be recalled；',
  downloadImportTemplate: 'Download Template',
  startImport: 'Start Import',
  productStock: 'Product Stock',
  specificationName: 'Specification Name',
  dataImport: 'Data Import',
  loadingImportTips: "Importing {len} pieces of data",
  dataValid: 'Checking Data',
  loadingValid: 'Now Checking',
  dataImportSuccess: 'Successfully import data',
  importException: 'Import Timed Out Or An Exception Occurred',
  dataIsEmpty: "Data Is Empty",
  dataImportFailed: "Failed to import data",
  importReminder: "Import Notice",
  bigSize: 'Exceeds the maximum import line of 1000',
  fileIsEmpty: 'File is empty',
  storeDoesNotExist: "Store does not exist",
  unknownMistake: "Unknown mistake",
  dataCanBeImported: "Correct Data",
  unableToImportData: "Error Data",
  downloadWrongData: "Download Error Data",
  importTemplateError: 'Wrong template',
  importOnlyCorrectData: "Import Correct Data",
  failedToGetStoreInformation: 'Failed to get store information',
  importTimeout: "Checking time out, please reduce the number of data or import in batches",
  productSelectLimit: "Select the upper limit of 1000",
  productNameMust: "Product name must be in at least one language",
  productCategory: "Item Category",
  selectProductCategory: "Select Item Category",
  productCategoryList: "Item Category List",
  selectedCategory: "Please tick a category！",
  pendingDataNotExist: "All the data to be updated no longer exist",
  itemCharge: 'Item charge',
  enableMultiCharge: 'Charge as multiple item ',
  dynamicCal: 'The charge of packaging fee will calculate base on the numbers of item.',
  example: 'For Example',
  per3Item: '$1 per 3 items',
  userBuyChargedOne$: 'When a user purchases 1-3 items, $1 will be charged;',
  userBuyChargedTwo$: 'When a user purchases 4-6 items, $2 will be charged，',
  andSoOn: 'And So On',
  packageFee: 'Total Packing Fee',
  importActualNumLarge1000: 'Import actual quantity greater than 1000',
  dataChanges: 'data changes',
  existJoinedActivityProduct: 'There are products that have participated in the event and cannot be deleted!',
  existJoinedActivityProductSingle: 'This item has already participated in the event, please exit the event and try again!',
  updateType: 'Update Type',
  overbigsize: 'Exceed maximum number, will export the first 2000 data',
  productTopicActivity: 'Product discount themed activities',
  storeRecommendation: 'Store Recommendation',
  storeRecommendationOverTips: 'There are already 5 products recommended by the store manager, please clean up and then set up',
  sortTips: 'Sorting is possible after selecting a menu',
  uploadImgTip:"Uploading {num} pictures",
  productImg:"Item Pictures",
  matchMethod:"Matching By:",
  selectMatchMethod:"Please select matching type",
  pleaseUploadPic:"Please upload pictures",
  uploadFailTip:"Failed to upload",
  downloadFailData:"Download failed data",
  uploadComplete:"Upload successful",
  success:"Successful",
  fail:"Failed",
  batchUploadPictures:"Batch Upload Pictures",
  MenuPreview: "Menu Preview",
  MenuType:"Menu Type",
  upload: "Upload",
  Prodcutdiscount: 'Prodcut discount',
  NormalMenu: 'Normal Menu',
  BestsellMenu: 'Best-sell Menu',
  RecommendMenu: 'Recommend Menu',
  SOPMenu: 'SOP Menu',
}
